import { FieldType, commercialMultiAdsParkingType } from '../config';

export function enrichConfigForMultiAds(offerConfig: FieldType[], isOfferMultiAds: boolean) {
  if (isOfferMultiAds) {
    return offerConfig.reduce<FieldType[]>((acc, config) => {
      if (config.type === 'floorNumber') {
        return [...acc, config, commercialMultiAdsParkingType];
      }

      return [...acc, config];
    }, []);
  }

  return offerConfig;
}
